/*****************************************************************************/
/*  File Name: bottomHalf.js                                                 */
/*  Date:      June 21, 2023                                                 */
/*  Author:    Christopher Cressman                                          */
/*  Purpose:   This is the bottom half of the roi calculator                 */
/*             Handles the following forms                                   */
/*             - Tier Select
/*             - Tip Selection
/*
/*****************************************************************************/

import React from 'react';
import { withTranslation } from 'react-i18next';

import styles from './styles/roi.module.scss';
import TierSelect from './tierSelect';
import TipSelect from './tipSelect';
import FreeTipSelect from './freeTipSelect';
import { useTierContext } from '../../context/tierContext';
import { useROIContext } from '../../context/roiContext';
import * as MODES from '../../constants/modes';
import { Grid } from '@mui/material';
import TipSelectGrowth from './tipSelectGrowth';
import Footer from '../Footer';
import TipSelectUpgrade from './tipSelectUpgrade';
import TipSelectUpgradedSystem from './tipSelectUpgradedSystem';
import { useSystemContext } from '../../context/systemContext';

function BottomHalf({ t }) {
  //Load all of the default component varaibles
  const { tiers } = useTierContext();
  const { selectedTier, roiMode } = useROIContext();
  const { upgradeSystem } = useSystemContext();

  const selectedTierName = tiers.find((t) => t.id === selectedTier)?.tierName;

  //console.log('this is my selected tier ----> ', tiers, selectedTier, selectedTierName);

  return (
    <div className={`${styles.bottomHalf} ${styles[selectedTierName]}`}>
      <div className={styles.tierSelect}>
        <TierSelect />
      </div>
      <div className={styles.tipSelect}>
        {roiMode === MODES.capital ? (
          <Grid item xs={12} container justifyContent='flex-start' alignItems='flex-start' spacing={3} className={styles.capitalTreatmentEntryGrid}>
            <Grid item xl={8} xs={12}>
              <TipSelect />
            </Grid>
            <Grid item xl={4} xs={12}>
              <FreeTipSelect />
            </Grid>
          </Grid>
        ) :
          roiMode === MODES.consumer ?
            (
              <Grid item xs={12} container justifyContent='flex-start' alignItems='flex-start' spacing={2} className={styles.consumerTreatmentEntryGrid}>
                <Grid item xl={6} xs={12}>
                  <TipSelect />
                </Grid>
                <Grid item xl={6} xs={12} className={styles.consumerTreatmentColumn}>
                  <TipSelectGrowth />
                  <FreeTipSelect consumerMode />
                </Grid>
              </Grid>
            ) :
            roiMode === MODES.upgrade ? (
              <Grid item xs={12} container justifyContent='flex-start' alignItems='flex-start'>
                <Grid item xl={6} xs={12}>
                  <TipSelectUpgrade />
                </Grid>
                <Grid item xl={6} xs={12} className={styles.upgradeTreatmentColumn}>
                  <TipSelectUpgradedSystem />
                  {upgradeSystem?.id ? <FreeTipSelect systemId={upgradeSystem.id} /> : null}
                </Grid>
              </Grid>
            ) :
              null
        }
      </div>
    </div>
  );
}

export default withTranslation()(BottomHalf);
